import React from "react";
import { Container } from "react-bootstrap";
import PdfViewerCard from "../../PdfViewerCard";
import "../../incidentes.css";

const PolizaMgavilan2025Sw = () => {
  const pdfUrl = `${process.env.REACT_APP_BUCKET}/pdf/polizas/251103-Poliza-de-Servicios_Switches.pdf`;
  /*const pdfUrl = "/pdf/251103-Poliza-de-Servicios_Switches.pdf";*/

  return (
    <>
      <Container fluid className="background-containerr">
        <div className="orgproc-header">
          <h1 className="orgproc-heading">Póliza 2025 Switches</h1>
        </div>
        <PdfViewerCard pdfUrl={pdfUrl} titulo="Póliza 2025 Switches" />
      </Container>
    </>
  );
};

 export default PolizaMgavilan2025Sw;
